import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import StyledText from './StyledTextInput';
import LookupButton from '../components/LookupButton';
/** Custom style in order to ensure the same UI between single and multiline inputs */

var useStyles = makeStyles({
  multiline: {
    padding: 0
  },
  inputMultiline: {
    paddingTop: 10.5,
    paddingBottom: 10.5,
    paddingLeft: 8,
    paddingRight: 8
  }
}, {
  name: 'ECTextAreaField'
});
/**
 * @param {import('../components/types').TextAreaFieldProps} props
 */

var TextAreaField = function TextAreaField(props) {
  var description = props.description,
      placeholder = props.placeholder,
      rows = props.rows,
      error = props.error,
      readonly = props.readonly;
  var value = props.value,
      maxCharacters = props.maxCharacters,
      active = props.active,
      fieldId = props.fieldId,
      dispatch = props.dispatch,
      variant = props.variant;
  var xpath = props.xpath,
      lookupVisiblity = props.lookupVisiblity;
  var classes = useStyles({});

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    var value = event.target.value;
    var charsLimitReached = value && maxCharacters && value.length > maxCharacters;
    if (!charsLimitReached) fieldLogic.onChange(fieldId, value, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var showLookupButton = xpath && lookupVisiblity !== 'hide';
  var InputProps = {
    endAdornment: showLookupButton ? React.createElement(LookupButton, {
      fieldId: fieldId,
      marginRight: 14
    }) : null,
    classes: classes
  };
  var hasError = !!error;
  return React.createElement(React.Fragment, null, React.createElement(StyledText, {
    InputProps: InputProps,
    placeholder: placeholder || '',
    disabled: readonly,
    multiline: true,
    rows: rows || 3,
    error: hasError,
    variant: variant,
    helperText: error || description || React.createElement(Typography, null, " "),
    value: value || '',
    inputRef: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange
  }));
};

export default React.memo(TextAreaField);